import { pageLinkNames } from 'src/app/constants/pageLinkNames';
export const mapPageIdToPageLinkName = (pageId: string) =>
  pageLinkNames[pageId];
